import { required, email } from "@rxweb/reactive-forms";
export default class ForgotPasswordForm {
    @required()
    @email({ message: "This value must be a valid email" })
    public email!: string;
}